import { rem } from "@mantine/core";
import IconProps from "./types";


const FeaturedCheckIcon = ({ size = 50, style, ...others }: IconProps) => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...others}
            style={{ width: rem(size), height: rem(size), ...style }}

        >
            <rect x="12.3506" y="0.944092" width="38" height="38" rx="8.14286" transform="rotate(15 12.3506 0.944092)" fill="#D1FADF" />
            <g filter="url(#filter0_b_911_7832)">
                <rect y="12" width="38" height="38" rx="8.14286" fill="#ECFDF3" fill-opacity="0.6" />
                <rect x="0.339286" y="12.3393" width="37.3214" height="37.3214" rx="7.80357" stroke="white" strokeOpacity="0.6" strokeWidth="0.678571" />
                <path d="M25.3337 26.25L16.6253 34.9583L12.667 31" stroke="#039855" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <filter id="filter0_b_911_7832" x="-10.8571" y="1.14286" width="59.7143" height="59.7143" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.42857" />
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_911_7832" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_911_7832" result="shape" />
                </filter>
            </defs>
        </svg>
    );
}



export default FeaturedCheckIcon